import React from 'react'
import { getDotIndexes } from './carousel-helpers'
import { useCarouselContext } from './carousel-context'

export function useCarouselKeyboard({
  keyCodeConfig,
  onUserNavigation
}: {
  keyCodeConfig: {
    firstSlide?: number[]
    lastSlide?: number[]
    nextSlide?: number[]
    previousSlide?: number[]
  }
  onUserNavigation: (e: React.TouchEvent | React.MouseEvent | React.KeyboardEvent) => void
}) {
  const { nextSlide, prevSlide, goToSlide, slideCount, slidesToScroll, slidesToShow, wrapAround, cellAlign } =
    useCarouselContext()

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    type KeyCodeFunction = keyof Exclude<typeof keyCodeConfig, undefined>
    let keyCommand: KeyCodeFunction | null = null
    ;(Object.keys(keyCodeConfig) as KeyCodeFunction[]).forEach((command) => {
      if (keyCodeConfig[command]?.includes(event.keyCode)) {
        keyCommand = command
      }
    })

    if (keyCommand === null) return

    // At this point we know some action is going to be triggered, so we
    // preventDefault to avoid the browser interpreting the key event and
    // stopPropagation to avoid any higher-up handlers from interpreting it.
    event.preventDefault()
    event.stopPropagation()

    switch (keyCommand) {
      case 'nextSlide':
        onUserNavigation(event)
        nextSlide()
        break
      case 'previousSlide':
        onUserNavigation(event)
        prevSlide()
        break
      case 'firstSlide':
      case 'lastSlide': {
        onUserNavigation(event)

        const dotIndices = getDotIndexes(slideCount, slidesToScroll, slidesToShow, wrapAround, cellAlign)

        if (keyCommand === 'firstSlide') {
          goToSlide(dotIndices[0])
        } else {
          goToSlide(dotIndices[dotIndices.length - 1])
        }
        break
      }
    }
  }
  return { onKeyDown }
}
